module.exports = __webpack_public_path__ + "img/sf_go_vn.f832223.jpeg";